import * as Popover from "@radix-ui/react-popover";
import { HelpCircle } from "react-feather";
import { cn } from "../../lib/utils";

interface HelpPopoverProps {
  text: string;
  className?: string;
}

export function HelpPopover({ text, className }: HelpPopoverProps) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          className={cn(
            "rounded-full focus:outline-none focus:ring-0",
            className
          )}
          aria-label="Help information"
        >
          <HelpCircle className="w-4 h-4 text-muted-foreground" />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="z-50 w-72 rounded-lg bg-card p-4 shadow-md border border-border animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
          sideOffset={5}
        >
          <p className="text-sm text-muted-foreground">{text}</p>
          <Popover.Arrow className="fill-white" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
